// ( function( $ ){

//     $( '.search-trigger' ).on( 'click', (e) => {
//         let is_visible = $( '.search-popup' ).is( ':visible' );
//         if( ! is_visible ){
//             $( '.search-popup' ).fadeIn();
//             $( '.search-input' ).focus();
//             e.stopPropagation();
//         }
//     });

//     $( document ).on( 'click', (e) => {
//         if( 
//             $( e.target ).closest( '.search-popup' ).length == 0
//             && $( '.search-popup' ).is( ':visible' )
//         ){
//             $( '.search-popup' ).fadeOut();
//         }
//     });

// })( jQuery );
document.querySelectorAll('.menu-search-form').forEach(form => {
    const input = form.querySelector('.menu-search-input');
    const button = form.querySelector('.menu-search-submit');

    const toggleButton = () => {
        const hasValue = input.value.trim().length > 0;
        button.disabled = !hasValue;
    };

    // Initial check (in case PHP didn't handle it)
    toggleButton();

    // Listen for user input
    input.addEventListener('input', toggleButton);
});